import { zendeskApis } from '@apis/dashboard/zendeskApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';

export const usePostZendeskTicket = (userId: number, d2dNo: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    async () => {
      const response = await zendeskApis.post('/dashboard/zendesk/{userId}/{d2dNo}/ticket/', {
        path: { userId, d2dNo },
      });

      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/zendesk/${d2dNo}/tickets/`]);
      },
    },
  );
};
